'use strict';

import BaseService from './base.service';

class ProcedureTemplatesService extends BaseService {
    /* @ngInject */
    constructor(ProcedureTemplate, SegaUser) {
        super(ProcedureTemplate, SegaUser);
    }

    removeItemTemplate(procedureTemplate, itemTemplate) {
        return this.Model.removeItemTemplate({
            procedureTemplateId: procedureTemplate.id,
            itemTemplateId: itemTemplate.id
        }).$promise;
    }

    addItemTemplate(procedureTemplate, itemTemplate) {
        return this.Model.addItemTemplate({
            procedureTemplateId: procedureTemplate.id,
            itemTemplateId: itemTemplate.id
        }).$promise;
    }
}

export default ProcedureTemplatesService;
